import React from 'react';

import { flagStyles } from '../settings';

const SvgGT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2136px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGT;
